var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewticket"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading || _vm.isLoading1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', [_c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', {
    staticStyle: {
      "border-bottom": "4px solid #636060"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('h5', {
    staticClass: "card-header"
  }, [_c('b', [_vm._v("Ticket Details")])]), _vm._v(" "), _c('a', {
    attrs: {
      "title": "Go To Listing"
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px",
      "float": "right",
      "margin-top": "-30px",
      "margin-right": "10px"
    },
    attrs: {
      "style": "font-size:18px; float:right; margin-top:-30px; margin-right:10px "
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Ticket No")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ticketNo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Subject")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subject))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Topic")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.topic))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.status))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.createdDate)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Assigned To")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.assignedTo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Client")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.clientNameDisplay))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Warehouse")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.warehouseNameDisplay))])])])])])]), _vm._v(" "), (_vm.s3UploadData.length) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('b', [_vm._v("Uploaded Attachemnts :")])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary "
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("File Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Uploaded Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Download")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.s3UploadData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.filename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.dateFormatDetail(data.createddatetime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-download fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Download File"
      },
      on: {
        "click": function($event) {
          _vm.viewDownloadDocument('download', data.s3url)
        }
      }
    })])])
  }))]), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('b', [_vm._v("Description :")])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('main', {
    attrs: {
      "id": "app"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('section', {
      ref: "chatArea",
      refInFor: true
    }, [(message.author === 'M') ? _c('span', {
      staticClass: "abc"
    }, [_vm._v(_vm._s(message.msgSender) + " Posted on  " + _vm._s(_vm.dateFormatDetail(message.date)))]) : _vm._e(), (message.author === 'M') ? _c('br') : _vm._e(), _vm._v(" "), (message.author != 'M') ? _c('span', {
      staticClass: "abc1"
    }, [_vm._v(_vm._s(message.msgSender) + " Posted on  " + _vm._s(_vm.dateFormatDetail(message.date)))]) : _vm._e(), (message.author != 'M') ? _c('br') : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "message",
      class: {
        'message-out': message.author === 'M',
        'message-in': message.author !== 'M'
      }
    }, [_c('a', [_vm._v(_vm._s(message.body1))]), _vm._v(" "), (message.sendUrl && (message.body == 'JPEG' || message.body == 'JPG' || message.body == 'PNG')) ? _c('a', {
      staticClass: "fa fa-picture-o fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Click To Download File"
      },
      on: {
        "click": function($event) {
          _vm.viewDownloadDocument(message)
        }
      }
    }) : _vm._e(), _vm._v(" "), (message.sendUrl && (message.body == 'PDF')) ? _c('a', {
      staticClass: "fa fa-file-pdf-o fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Click To Download File"
      },
      on: {
        "click": function($event) {
          _vm.viewDownloadDocument(message)
        }
      }
    }) : _vm._e(), _vm._v(" "), (message.sendUrl && (message.body == 'CSV')) ? _c('a', {
      staticClass: "fa fa-file fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Click To Download File"
      },
      on: {
        "click": function($event) {
          _vm.viewDownloadDocument(message)
        }
      }
    }) : _vm._e(), _vm._v(" "), (message.sendUrl && (message.body == 'XLS' || message.body == 'XLSX')) ? _c('a', {
      staticClass: "fa fa-file-excel-o fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Click To Download File"
      },
      on: {
        "click": function($event) {
          _vm.viewDownloadDocument(message)
        }
      }
    }) : _vm._e(), _vm._v(" "), (message.sendUrl && (message.body != 'XLS' && message.body != 'XLSX' && message.body != 'CSV' && message.body != 'PDF' && message.body != 'JPEG' && message.body != 'JPG' && message.body != 'PNG')) ? _c('a', {
      staticClass: "fa fa-file fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Click To Download File"
      },
      on: {
        "click": function($event) {
          _vm.viewDownloadDocument(message)
        }
      }
    }) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.templateDescription),
      expression: "templateDescription"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('description')
    },
    attrs: {
      "id": "templateDescription",
      "name": "description",
      "type": "text",
      "placeholder": "Comment"
    },
    domProps: {
      "value": (_vm.templateDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templateDescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description')),
      expression: "errors.has('description')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('description')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file",
      "name": "csv"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button"
    },
    on: {
      "click": _vm.replyTicketValidate
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Reply")]), _vm._v(" \n                    ")])])])])])])])])], 1)])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b3ccede0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3ccede0","hasScoped":true}!./src/views/components/viewticket/viewticket.component.html
// module id = 1866
// module chunks = 0